import { render } from "./live.vue?vue&type=template&id=3954b4a7&lang=pug&bindings={\"postButton\":\"options\"}"
import script from "./live.vue?vue&type=script&lang=js"
export * from "./live.vue?vue&type=script&lang=js"

import "./live.vue?vue&type=style&index=0&lang=sass"
script.render = render

export default script